module.exports = __webpack_public_path__ + "img/scene-icon-1.9eaef568.png";